/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withExpContextRule } from '@thd-olt-component-middleware/pip';

import { BIPRedirector }
from '@thd-nucleus/app-render';

import {
  BundlePageAnalytics, BundleMetadata, BundleStickyNav, BundleProductOverview, BundleMediaGallery, BundlePrice, BundlePromotion, BundleConsumerCardMessaging, BundleAlert, BundleTrackOOS, BundleSalientPoints, BundleProductList, BundleSummary, BundleDeliveryDate, BundleBuybox, BundleProductOverviewAccordionTitle, BundleSpecificationsAccordionTitle, BundleWhatWeOffer
}
from '@thd-olt-component-react/product-bundle';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { DisclaimerMessage }
from '@thd-olt-component-react/disclaimer-message';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { TextAnExpert }
from '@thd-olt-component-react/text-an-expert';

import { DynamicRecsWrapperBip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { EmtLinks }
from '@thd-olt-component-react/emt-links';

export { BIPRedirector };

export { BundlePageAnalytics };

export { BundleMetadata };

export { BundleStickyNav };

export { Breadcrumbs };

export { ProductInfoBar };

export { Discontinued };

export { BundleProductOverview };

export { BundleMediaGallery };

export { PIPSharebelt };

export { BundlePrice };

export { BundlePromotion };

export { DisclaimerMessage };

export { BundleConsumerCardMessaging };

export { BundleAlert };

export { BundleTrackOOS };

export { BundleSalientPoints };

export { BundleProductList };

export { BundleSummary };

export { BundleDeliveryDate };

export { BundleBuybox };

export { BundleProductOverviewAccordionTitle };

export { BundleSpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { BundleWhatWeOffer };

export { TextAnExpert };

export { DynamicRecsWrapperBip };

export { RecentlyViewedWrapper };

export { EmtLinks };

const SlotA1 = withLayout(
  [

    BIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    BundlePageAnalytics,

  ],

);

const SlotA3 = withLayout(
  [

    BundleMetadata,

  ],

);

const SlotA4 = withLayout(
  [

    BundleStickyNav,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotD1 = withLayout(
  [

    Discontinued,

  ],

);

const SlotE1 = withLayout(
  [

    BundleProductOverview,

  ],

);

const SlotE2 = withLayout(
  [

    BundleMediaGallery,

  ],

);

const SlotE3 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotF1 = withLayout(
  [

    BundlePrice,

  ],

);

const SlotF2 = withLayout(
  [

    BundlePromotion,

  ],

);

const SlotF3 = withLayout(
  [

    DisclaimerMessage,

  ],

);

const SlotF4 = withLayout(
  [

    BundleConsumerCardMessaging,

  ],

);

const SlotF5 = withLayout(
  [

    BundleAlert,

  ],

);

const SlotF6 = withLayout(
  [

    BundleTrackOOS,

  ],

);

const SlotF7 = withLayout(
  [

    BundleSalientPoints,

  ],

);

const SlotF8 = withLayout(
  [

    BundleProductList,

  ],

);

const SlotF9 = withLayout(
  [

    BundleSummary,

  ],

);

const SlotF10 = withLayout(
  [

    BundleDeliveryDate,

  ],

);

const SlotF11 = withLayout(
  [

    BundleBuybox,

  ],

);

const SlotG2 = withLayout(
  [

    BundleWhatWeOffer,

  ],

);

let RulesMiddleware_MiddlewareSlot_G3 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G3 = withExpContextRule(RulesMiddleware_MiddlewareSlot_G3, { render: { name: 'isConsumerApp', negate: true } });

RulesMiddleware_MiddlewareSlot_G3 = withExpContextRule(RulesMiddleware_MiddlewareSlot_G3, { render: { name: 'isMobile' } });

const SlotG3 = withLayout(
  [

    TextAnExpert,

  ],

  RulesMiddleware_MiddlewareSlot_G3

);

const SlotG4 = withLayout(
  [

    DynamicRecsWrapperBip,

  ],

);

const SlotG5 = withLayout(
  [

    DynamicRecsWrapperBip,

  ],

);

const SlotG6 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotG7 = withLayout(
  [

    EmtLinks,

  ],

);

const ssr = typeof window === 'undefined';

const SlotG1Index0DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
    .BundleProductOverviewAccordionTitle
  : {};

const SlotG1Index0DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
    .BundleProductDetails
  : {};

const SlotG1Index1DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
    .BundleSpecificationsAccordionTitle
  : {};

const SlotG1Index1DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-bundle'))
    .BundleSpecifications
  : {};

const SlotG1Index2DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionTitle
  : {};

const SlotG1Index2DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : {};

const SlotG1Index3DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionTitle
  : {};

const SlotG1Index3DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : {};

export {

  SlotA1,

  SlotA2,

  SlotA3,

  SlotA4,

  SlotB1,

  SlotC1,

  SlotD1,

  SlotE1,

  SlotE2,

  SlotE3,

  SlotF1,

  SlotF2,

  SlotF3,

  SlotF4,

  SlotF5,

  SlotF6,

  SlotF7,

  SlotF8,

  SlotF9,

  SlotF10,

  SlotF11,

  SlotG2,

  SlotG3,

  SlotG4,

  SlotG5,

  SlotG6,

  SlotG7,

  SlotG1Index0DataModelK0,

  SlotG1Index0DataModelBodyK0,

  SlotG1Index1DataModelK0,

  SlotG1Index1DataModelBodyK0,

  SlotG1Index2DataModelK0,

  SlotG1Index2DataModelBodyK0,

  SlotG1Index3DataModelK0,

  SlotG1Index3DataModelBodyK0,

};
